var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColorTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 3.25V2.5C4 1.39543 4.89543 0.5 6 0.5H8C9.10457 0.5 10 1.39543 10 2.5V3.25H12.5C12.9142 3.25 13.25 3.58579 13.25 4C13.25 4.41421 12.9142 4.75 12.5 4.75H12V12.5C12 13.6046 11.1046 14.5 10 14.5H4C2.89543 14.5 2 13.6046 2 12.5V4.75H1.5C1.08579 4.75 0.75 4.41421 0.75 4C0.75 3.58579 1.08579 3.25 1.5 3.25H4ZM5.5 3H8.5V2.5C8.5 2.22386 8.27614 2 8 2H6C5.72386 2 5.5 2.22386 5.5 2.5V3Z",
    fill: "#8E97A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorTrash);
export default __webpack_public_path__ + "static/media/colorTrash.c2779b4577bd5dffc73d1965d1a6779f.svg";
export { ForwardRef as ReactComponent };